import { defaultLocale, getLocaleFromPathname } from '@/lib/i18n';

/**
 * Prefix an app path with the locale segment (`localePrefix: always`).
 * Use for `window.location` when a full reload is required but locale must be preserved.
 */
export function localeAwareHref(path: string, locale?: string): string {
  const resolvedLocale =
    locale ??
    (typeof window !== 'undefined'
      ? getLocaleFromPathname(window.location.pathname)
      : defaultLocale);
  const normalized = path.startsWith('/') ? path : `/${path}`;

  if (normalized === '/') {
    return `/${resolvedLocale}`;
  }

  return `/${resolvedLocale}${normalized}`;
}

export function navigateWithLocale(path: string, locale?: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.location.assign(localeAwareHref(path, locale));
}
